import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Grid,
  makeStyles,
  MenuItem,
  Radio,
  Typography,
  FormControlLabel
} from "@material-ui/core";
import {
  SelectValidator,
  TextValidator,
} from "react-material-ui-form-validator";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import ValidatedDatePicker from "../../../compartidos/ValidatedDatePicker";
import { fetchSeccionales } from "../../../../actions/cbos/seccionales";
import { red } from "@material-ui/core/colors";

const useStyles = makeStyles((theme) => ({
  title: {
    color: theme.palette.primary.main,
  },
  baja: {
    color: red,
  },
  switchBase: {
    color: "#bdbdbd",
    "&$checked": {
      transform: "translateX(16px)",
      color: "#4CAF50",
      "& + $track": {
        backgroundColor: "#3E8040",
        opacity: 1,
        border: "none",
      },
    },
  },
  checked: {},
  track: {},
}));

export const FormReclamo = (props) => {
  const { dataAfiliado, formValues, setearValor, handleInputChange } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const { items } = useSelector((state) => state.seccionales);

  useEffect(() => {
    dispatch(fetchSeccionales());
  }, [dispatch]);

  const validadoresTelefono =
    formValues?.telefono?.length === 10 || formValues?.celular?.length === 10
      ? ["isNumber", "maxNumber:9999999999", "minNumber:999999999"]
      : ["required", "isNumber", "maxNumber:9999999999", "minNumber:999999999"];

  const errorMessageTelefono =
    formValues?.telefono?.length === 10 || formValues?.celular?.length === 10
      ? ["Solo números", "Verifique su teléfono", "Verifique su telefono"]
      : [
        "El teléfono es requerido",
        "Solo números",
        "Verifique su teléfono",
        "Verifique su teléfono",
      ];

  console.log(formValues.urgente)
  return (
    <>
      <Grid item xs={12}>
        <Grid container justify="center" alignItems="center">
          <Grid
            item
            xs={12}
            md={12}
            style={{ display: "flex", flexDirection: "column" }}
          >
            <Typography align="left" variant="button" color="secondary">
              <span>
                BENEFICIARIA/O:{" "}
                <span className={classes.title}>
                  {dataAfiliado?.apellido_y_nombre}
                </span>
                {dataAfiliado?.fecha_baja !== null && (
                  <>
                    {" "}
                    <span style={{ color: "red" }}>(BENEFICIARIA/O DE BAJA)</span>
                  </>
                )}

              </span>
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={12}
            style={{ display: "flex", flexDirection: "column" }}
          >
            <Typography align="left" variant="button" color="secondary">
              <span>
                NRO BENEFICIARIA/O:{" "}
                <span className={classes.baja}>
                  {formValues?.nroBeneficiario}
                </span>
              </span>
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={12}
            style={{ display: "flex", flexDirection: "column" }}
          >
            <Typography align="left" variant="button" color="secondary">
              <span>
                USUARIO CARGA:{" "}
                <span className={classes.title}>
                  {formValues.nombreUsuario}
                </span>
              </span>
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={4}>
        <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
          <ValidatedDatePicker
            fullWidth
            margin="normal"
            label="Fecha Carga"
            format="dd/MM/yyyy"
            okLabel="Aceptar"
            maxDate={new Date()}
            clearLabel="Limpiar"
            cancelLabel="Cancelar"
            value={formValues.fechaCarga}
            onChange={(date) => {
              setearValor("fechaCarga", date);
            }}
            KeyboardButtonProps={{
              "aria-label": "change date",
            }}
            disabled
          />
        </MuiPickersUtilsProvider>
      </Grid>
      {/* <Grid item xs={3}>
        <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
          <ValidatedDatePicker
                fullWidth
                margin="normal"
                label="Fecha Ingreso"
                format="dd/MM/yyyy"
                okLabel="Aceptar"
                maxDate={new Date()}
                clearLabel="Limpiar"
                cancelLabel="Cancelar"
                value={formValues.fechaRecepcion}
                onChange={(date) => {
                setearValor("fechaRecepcion", date);
                }}
                KeyboardButtonProps={{
                "aria-label": "change date",
                }}
            />
            </MuiPickersUtilsProvider>
        </Grid> */}
      <Grid item xs={4}>
        <SelectValidator
          fullWidth
          margin="normal"
          label="SECCIONAL"
          name="seccional"
          disabled
          value={formValues?.seccional}
          onChange={handleInputChange}
          InputLabelProps={{ style: { fontWeight: "bold" } }}
          validators={["required"]}
          errorMessages={["Este campo es obligatorio"]}
          style={{ color: "#000" }}
        >
          {items.map((e) => (
            <MenuItem key={e.id_seccional} value={e.id_seccional}>
              {e.descripcion_seccional}
            </MenuItem>
          ))}
        </SelectValidator>
      </Grid>
      {/* <Grid item xs={3}>
        <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
          <ValidatedDatePicker
                fullWidth
                margin="normal"
                label="Fecha Nacimiento"
                format="dd/MM/yyyy"
                okLabel="Aceptar"
                disabled
                maxDate={new Date()}
                clearLabel="Limpiar"
                cancelLabel="Cancelar"
                value={formValues.fechaNacimiento}
                onChange={(date) => {
                setearValor("fechaNacimiento", date);
                }}
                KeyboardButtonProps={{
                "aria-label": "change date",
                }}
            />
            </MuiPickersUtilsProvider>
        </Grid>           */}
      {/* <Grid item xs={3}>
            <TextValidator
              variant="outlined"
              margin='normal'
              fullWidth
              label="Número Documento"
              autoComplete="off"
              name="nroDoc"
              type="number"
              disabled
              value={formValues?.nroDoc} 
              InputLabelProps={{ style: { fontWeight: 'bold' } }}
            />
          </Grid> */}
      {/* <Grid item xs={4}>
            <TextValidator
              variant="outlined"
              margin='normal'
              fullWidth
              label="Número Beneficiario"
              autoComplete="off"
              name="nroBeneficiario"
              type="number"
              disabled
              value={formValues?.nroBeneficiario} 
              InputLabelProps={{ style: { fontWeight: 'bold' } }}
            />
          </Grid> */}

      <Grid item xs={4}>
        <TextValidator
          variant="outlined"
          margin="normal"
          fullWidth
          label="Correo Electrónico"
          autoComplete="off"
          name="email"
          type="email"
          value={formValues?.email}
          validators={["required"]}
          errorMessages={["Este campo es obligatorio"]}
          onChange={handleInputChange}
          InputLabelProps={{ style: { fontWeight: "bold" } }}
        />
      </Grid>
      <Grid item xs={4}>
        <TextValidator
          variant="outlined"
          margin="normal"
          fullWidth
          label="Número Teléfono"
          autoComplete="off"
          name="telefono"
          type="number"
          value={formValues?.telefono}
          onChange={handleInputChange}
          validators={validadoresTelefono}
          errorMessages={errorMessageTelefono}
          InputLabelProps={{ style: { fontWeight: "bold" } }}
        />
      </Grid>
      <Grid item xs={4}>
        <TextValidator
          variant="outlined"
          margin="normal"
          fullWidth
          label="Número Celular"
          autoComplete="off"
          name="celular"
          type="number"
          value={formValues?.celular}
          onChange={handleInputChange}
          validators={validadoresTelefono}
          errorMessages={errorMessageTelefono}
          InputLabelProps={{ style: { fontWeight: "bold" } }}
        />
      </Grid>
      {/* <Grid
        item
        xs={12}
        style={{ display: "flex", justifyContent: "center", gap: "2em" }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
          }}
          onClick={() => {
            setearValor("urgente", formValues.urgente === 1 ? 0 : 1);
          }}
        >
          <Radio
            checked={formValues.urgente === 1}
            color="primary"
            name="urgente"
          />
          <Typography>URGENTE</Typography>
        </div>
      </Grid> */}
      <Grid
        item
        xs={12}
        style={{ display: "flex", justifyContent: "center", gap: "2em" }}
      >
        <div>
          <FormControlLabel
            control={
              <Radio
                checked={formValues.urgente === 0}
                onChange={() => setearValor("urgente", 0)}
                value="0"
                name="radio-button-demo"
                inputProps={{ 'aria-label': '0' }}
                style={{ color: 'green' }}
                title="Verde: criticidad baja Plazo de respuesta: 7 días hábiles. Se refiere a situaciones que, aunque no son urgentes, impactan en la experiencia de la
                       persona beneficiaria y su percepción sobre la calidad de servicio (por ejemplo: desacuerdo con la baja o cambio de un prestador)."
              />
            }
            label="Verde"
          />

          <FormControlLabel
            control={
              <Radio
                checked={formValues.urgente === 2}
                onChange={() => setearValor("urgente", 2)}
                value="2"
                name="radio-button-demo"
                inputProps={{ 'aria-label': '2' }}
                style={{ color: '#ffcf33' }}
              />
            }
            label="Amarillo"
            title="Amarillo: criticidad media-baja Plazo de respuesta: 72 horas. Se refiere a situaciones que requieren una pronta respuesta, pero no representan
                   un riesgo inmediato ni para la persona beneficiaria, ni para la organización (por ejemplo: suspensión de servicios de parte de un prestador)."
          />
          <FormControlLabel
            control={
              <Radio
                checked={formValues.urgente === 1}
                onChange={() => setearValor("urgente", 1)}
                value="1"
                name="radio-button-demo"
                inputProps={{ 'aria-label': '1' }}
                style={{ color: 'red' }}
              />
            }
            label="Rojo"
            title="Rojo: criticidad alta. Plazo de respuesta: 24 horas.
                   Se refiere a situaciones que comprometen la salud de la persona beneficiaria (por ejemplo: un paciente con diabetes sin acceso a la insulina),
                   como también aquellas que comprometan la reputación pública de la organización (por ejemplo: situaciones que toman un gran protagonismo
                   en las redes sociales/prensa)."
          />
        </div>
      </Grid>
    </>
  );
};
